{
  "yourReports": "Your reports",
  "selectReport": "Select report",
  "myReport": "My report",
  "save": "Save",
  "cancel": "Cancel",
  "delete": "Delete",
  "new": "New",
  "edit": "Edit",
  "transactions": "Transactions",
  "duplicate": "Duplicate",
  "balances": "Balances",
  "history": "History",
  "howToUseReports": "How to use reports",
  "switchToProjects": "Switch to project data",
  "switchToDashboard": "Switch to dashboard data",
  "tooltips": {
    "new": "Create a new report",
    "edit": "Edit the selected report",
    "delete": "Delete the selected report",
    "duplicate": "Make a copy of the selected report"
  }
}
